import PrivacyPolicyModal from './privacy-policy-modal';

export default PrivacyPolicyModal;
